import React, { useState, useEffect, useCallback } from "react";
import ObjectForm from "../../Common/ObjectForm";
import http from "../../Common/RestAPIHandler";
import countryCodes from "../../Common/CountryCodes";
import ScreenLoader from "../../Common/Loader";

const EmployeeForm = (props) => {
  const [formFields, setFormFields] = useState();
  const [categories, setCategories] = useState();
  const [category, setCategory] = useState();
  const [sites, setSites] = useState();
  const [loadData, setLoadData] = useState(false);
  const [status, setStatus] = useState(true);
  var countryCodeMap = {};

  Object.keys(countryCodes).forEach(function (c) {
    if (!countryCodeMap[countryCodes[c].code]) {
      countryCodeMap[countryCodes[c].code] = countryCodes[c].name;
    } else {
      countryCodeMap[countryCodes[c].code] =
        countryCodeMap[countryCodes[c].code] + " / " + countryCodes[c].name;
    }
  });

  Object.entries(countryCodeMap).forEach(([key, value]) => {
    countryCodeMap[key] = value + " (" + key + ")";
  });

  useEffect(() => {
    setLoadData(true);
    http.Get(
      `categories?category_type=Employee Type`,
      (data) => {
        var valueMap = {};
        for (let i = 0; i < data.length; i++) {
          valueMap[data[i].id] = data[i].category_name;
          if (data[i].is_default) {
            setCategory(data[i].id);
          }
        }
        setCategories(valueMap);
        setLoadData(false);
      },
      () => {}
    );

    http.Get(
      `companies/${props.user.company_id}/sites`,
      (data) => {
        var valueMap = {};
        for (let i = 0; i < data.length; i++) {
          valueMap[data[i].id] = data[i].site_name;
        }
        setSites(valueMap);
        setLoadData(false);
      },
      () => {}
    );

    if (props.objectId) {
      http.Get(
        `company_employees/${props.objectId}`,
        (object) => {
          setStatus(object.status);
          setLoadData(false);
        },
        () => {}
      );
    }
  }, [props.objectId, props.user.company_id]);

  useEffect(() => {
    if (
      sites &&
      categories &&
      countryCodeMap &&
      props.objectId !== undefined &&
      !props.user.role.employees_hidden &&
      status !== undefined
    ) {
      setFormFields([
        {
          id: "employee_name",
          label: "EMPLOYEE NAME *",
          type: status ? "text" : "readonly",
        },
        {
          id: "email",
          label: "EMAIL",
          type: "email",
        },
        {
          id: "location_id",
          label: "SITE",
          type: "select",
          valueMap: sites,
        },
        {
          id: "phone_number",
          label: "PHONE NUMBER",
          type: "text",
        },
        {
          id: "mobile",
          label: "MOBILE",
          type: "text",
        },
        {
          id: "country_code",
          label: "COUNTRY CODE",
          type: "select",
          valueMap: countryCodeMap,
        },
        {
          id: "short_note",
          label: "SHORT NOTE",
          type: "text",
        },
        {
          id: "work_station",
          label: "WORKSTATION",
          type: "text",
        },
        {
          id: "category",
          label: "CATEGORY",
          type: "select",
          valueMap: categories,
        },
        {
          id: "status",
          label: "ACTIVE",
          type: "radio",
          onChange: (e, object, setObject, setErrors, value) => {
            setStatus(!object[e.target.name]);
            setObject({
              ...object,
              [e.target.name]: !object[e.target.name],
            });
          },
        },
        {
          id: "is_hidden",
          label: "HIDDEN",
          type: "radio",
          hide: !props.user.role.employees_hidden,
        },
        {
          id: "is_billing_contact",
          label: "BILLING CONTACT",
          type: "radio",
        },
        {
          id: "dataMappings",
          label: "RELATED ENTRIES",
          type: "dataMapping",
          model: "Employee",
          objectId: props.objectId,
        },
      ]);
    }
  }, [
    sites,
    categories,
    countryCodeMap,
    props.objectId,
    props.user.role.employees_hidden,
    status,
  ]);

  return (
    <div>
      {loadData && <ScreenLoader/>}
      {formFields && (
        <ObjectForm
          {...props}
          url={`company_employees`}
          formName={"Employees"}
          formFields={formFields}
          object={{
            company_id: props.user.company_id,
            status: true,
            category: category,
          }}
        />
      )}
    </div>
  );
};

export default EmployeeForm;
